import { createFileRoute } from "@tanstack/react-router";
import AdminAppVersionPage from "@/admin/pages/app-version";

export const Route = createFileRoute("/admin/app-version")({
  component: AdminAppVersionPage,
});
